export default __webpack_public_path__ + "static/thema-1-cropped-d49698129a06d052c12e211f6375e06c.jpg";